import React from 'react';
import { Box, Typography } from '@mui/material';
import { Image } from '@mui/icons-material';

const NoImageTiny = ({ 
  width = 40, 
  height = 40,
  borderRadius = "4px",
  iconSize = 16,
  textSize = "caption",
  bgcolor = "grey.200",
  iconColor = "grey.500",
  textColor = "grey.500",
  text = "No Preview"
}) => {
  return (
    <Box sx={{ 
      width, 
      height,
      bgcolor,
      borderRadius,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 0.25
    }}>
      <Image sx={{ fontSize: iconSize, color: iconColor }} />
      <Typography variant={textSize} color={textColor} sx={{ fontSize: '0.6rem' }}>
        {text}
      </Typography>
    </Box>
  );
};

export default NoImageTiny;
